<template>
    <VJoyWrapper class="task-list-completed" direction="column" row-gap="6" align="flex-start" no-margin>
        <VJoyHighlight level="success" display-icon>
            <template #highlight-title>{{ $t('profile.section.task.list.completed.highlight.title') }}</template>
            {{ $t('profile.section.task.list.completed.highlight.subtitle') }}
        </VJoyHighlight>
        <VJoyWrapper direction="row" column-gap="2" wrap="nowrap" no-margin>
            <VJoyBadgeLevel type="supermalter" :visible-text="false" />
            <VJoyText preset="primary-400">{{ $t('profile.section.task.list.completed.points.earned', {0: pointsEarned}) }}</VJoyText>
            <VJoyLink :href="$t('profile.section.task.list.completed.link')" target="_blank">
                {{ $t('generic.knowmore.aria.label') }}
            </VJoyLink>
        </VJoyWrapper>
        <TaskListProgressBar :tasks="tasksInfo" />
    </VJoyWrapper>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {useAsyncData, useHostSettings} from '#imports';
    import {VJoyBadgeLevel, VJoyHighlight, VJoyLink, VJoyText, VJoyWrapper} from '@maltjoy/core-vue';
    import TaskListProgressBar from './TaskListProgressBar.vue';
    import type {TaskListItemType} from '../types/TaskListItemType';

    defineProps<{
        tasksInfo: TaskListItemType[];
    }>();

    const {data: hostSettings} = await useAsyncData('host-settings', () => useHostSettings(), {deep: true});
    // Hardcoded for now but could be fetched from the backend
    const pointsEarned = computed(() => {
        switch (hostSettings.value?.country) {
            case 'DE':
            case 'BE':
            case 'ES':
            case 'NL':
                return 500;
            default:
                return 200;
        }
    });
</script>

<style lang="scss" scoped>
    @use '@malt/joy-entrypoint' as joy;

    .task-list-completed {
        :deep(.joy-highlight) {
            align-items: center;

            a {
                color: var(--joy-color-secondary-30);
                text-decoration: none;
                white-space: normal;

                @include joy.screen_xs(min) {
                    white-space: nowrap;
                }
            }
        }

        &__highlight-text {
            color: var(--joy-color-text-default);
        }
    }
</style>
